module.exports = require('./forEach');



// WEBPACK FOOTER //
// ./~/lodash-compat/collection/each.js